import { UserProfile } from 'services/user/userModels';

export interface CreateCompanyRequest {
  name: string;
}

export interface CreateSiteRequest {
  companyId: number;
  siteName: string;
  siteType: SiteType;
  isFederal: boolean;
  state: string;
  status: SiteStatus;
  managerEmail: string;
  managerFirstName: string;
  managerLastName: string;
  createdBy: UserProfile;
  creatingUserIsManager: boolean;
}

export type NewSiteCreationRequest = {
  siteId: number;
  requestedByUserId: number;
  managedByUserId: number;
};
export interface UpdateSiteRequest {
  siteId: number;
  siteName: string;
  siteType: SiteType;
  isFederal: boolean;
  state: string;
}

export interface Company {
  companyId: number;
  createdAt: string;
  name: string;
  sites?: Site[];
}

export interface Site {
  companyId: number;
  siteId: number;
  createdAt: string;
  name: string;
  state: string;
  status: SiteStatus;
  siteType: SiteType;
  isFederal: boolean;
  managers: SiteManager[];
  currentUserRoles?: string[];
  awaitingAccessRequest?: boolean;
}

export interface SiteManager {
  name: string;
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
  roles: string[];
}

export type SiteType = 'non-construction' | 'construction' | 'mobile';

/**
 * "pending" site status - reserved for company admin site requests
 */
export type SiteStatus = 'active' | 'evaluation' | 'pending' | 'suspended';
export type ModifiableSiteStatus = Exclude<SiteStatus, 'pending'>;
export const editableSiteStatus: ModifiableSiteStatus[] = ['active', 'evaluation', 'suspended'];

export const siteTypeNames: Record<SiteType, string> = {
  'non-construction': 'Non construction fixed site',
  'construction': 'Construction',
  'mobile': 'Mobile workforce'
};

export class DuplicateCompanyError extends Error { }
export class DuplicateSiteError extends Error { }

/** Stripped down company interface for displaying summary in company list */
export interface CompanyListItem {
  companyId: number;
  createdAt: string;
  name: string;
  siteCount: number;
}

export interface SiteListItem {
  siteId: number;
  name: string;
  state: string;
  type: string;
  createdAt: string;
  siteUsers: SiteUserDetails[];
  status: ModifiableSiteStatus;
  memberId: string;
}

export type PendingSiteRequest = {
  companyId: number;
  companyName: string;
  siteId: number;
  siteName: string;
  state: string;
  type: string;
  requestedOn: string;
  siteUsers: SiteUserDetails[];
  memberId: string;
};

export type SiteUserDetails = {
  userId: number;
  name: string;
  email: string;
  roles: string[];
};
export interface CompanySitesListItem {
  companyId: number;
  name: string;
  sites: SiteListItem[];
}

export interface AdminSiteUpdateRequest {
  siteId: number;
  status?: ModifiableSiteStatus;
  memberId?: string;
}

export type UpdateCompanyRequest = {
  companyId: number;
  companyName: string;
};

export type UpdatePendingSiteRequest = {
  siteId: number;
  shouldAccept: boolean;
  updatedByUserId: number;
};

export type PendingSiteDetails = {
  companyName: string;
  siteName: string;
  invitingUserFirstName: string;
  invitingUserLastName: string;
  invitingUserEmail: string;
  invitingUserId: number;
  siteManagerFirstName: string;
  siteManagerLastName: string;
  siteManagerEmail: string;
  siteManagerUserId: number;
  isSiteManagerActive: boolean;
};